import React from "react"

import ProjectIcon from '../../../../../../core/gd-components/icons/project/project-icon-ui5'
import ProjectPathProperty from "../../../../../../core/gd-ui/project-path/project-path-property"
import {QuickSearchResultProps} from "./@type"
import {ItemIconSize} from "../../../../../../core/gd-components/icons/@const";

export default function QuickSearch_ResultProject(props: QuickSearchResultProps) {

    const project = props.searchResult.item

    const classes = Classes("row ui5-list-item", props.className, {
        'selected': props.searchResult.index === props.quickSearch.keyboardIterator.currentIndex
    });

    return (
        <div className={classes} onClick={props.searchResult.onClick}>
            <div className="cell">
                <div className="title">
                    <div className="icon-22 m-r-10">
                        <ProjectIcon projectId={project.id} size={ItemIconSize.SIZE_16} hint={false} colorize={true}/>
                    </div>
                    <div className="ui5-txt-default max-w-250">{project.name}</div>
                </div>
            </div>
            <div className="cell align-r">
                <ProjectPathProperty className="max-w-200" projectId={project.id} showEmptyRoot={true} maxFirstParents={2} showParentsOnly={true}/>
            </div>
        </div>
    )

}
